import React from 'react';

import RulesTable from './RulesTable';

import classes from './TableContainer.module.css';

const TableContainer = ({
    setSelectedRule,
    setIsOpenDebugger,
    setIsOpenRuleBuilder,
    setIsOpenTargets,
    selectedRule,
    ...props
}) => {

    return (
        <div className={classes.TableContainer}>
            <div className={classes.GridContainer}>
                <RulesTable
                    setSelectedRule={setSelectedRule}
                    setIsOpenDebugger={setIsOpenDebugger}
                    setIsOpenRuleBuilder={setIsOpenRuleBuilder}
                    setIsOpenTargets={setIsOpenTargets}
                    selectedRule={selectedRule}
                />
            </div>
        </div>
    );
};

export default TableContainer;
